export var MediaQueries;
(function (MediaQueries) {
    MediaQueries["small"] = "@media screen and (max-width: 640px)";
})(MediaQueries || (MediaQueries = {}));
//# sourceMappingURL=mediaQueries.js.map